import api from '@/api/index'

const state = {
    // type_list:[],//类型资源列表
}

const mutations = {
    // set_ids_vuex(state,val){
    //     state.ids = val
    // }
}

const actions = {
    //催审配置
    operate_boostCheckConfig({commit, dispatch, state, rootState}, parasm = {}) {
        api.operate_boostCheckConfig(parasm.data).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    },
    //催审配置详情
    operate_boostCheckDetail({commit, dispatch, state, rootState}, parasm = {}) {
        api.operate_boostCheckDetail(parasm.data).then(res => {
            parasm.scCallback && parasm.scCallback(res);
        }).catch(res => {
        })
    }
}

const getters = {
    // type_list(){
    //     return state.type_list
    // }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
